import { preloadData } from '$app/navigation';
import type { TOverlayData } from './types';

export const preloadDataWithFollow = async <T>(
    url: string
): Promise<{ type: 'loaded'; status: number; data: T }> => {
    try {
        const result = await preloadData(url);
        if (result.type === 'redirect') return preloadDataWithFollow<T>(result.location);
        return result as { type: 'loaded'; status: number; data: T };
    } catch (e: unknown) {
        return Promise.reject(e);
    }
};

export const preloadPageData = async <T = TOverlayData>(pathname: string) => {
    try {
        const { data } = await preloadDataWithFollow<T>(pathname);
        return data;
    } catch (e: unknown) {
        return Promise.reject(e);
    }
};

export const stripOrigin = (url: URL) => url.href.replace(url.origin, '');

export const OVERLAY_MANAGER_CONTEXT_KEY = Symbol('OverlayManagerContext');
export class OverlayManagerContext {
    closeOverlay: () => void;
    constructor(closeOverlay: () => void = () => {}) {
        this.closeOverlay = () => closeOverlay();
    }
}
